import type { ReactNode } from 'react';

import type { MultiValueProps } from 'react-select';
import { components } from 'react-select';

export function newMultiValue<T>({ getMultiValueLabel }: { getMultiValueLabel?: (data: T) => ReactNode }) {
  function MultiValueComponent({ data, children, ...props }: MultiValueProps<T>) {
    if (getMultiValueLabel) {
      return (
        <components.MultiValue data={data} {...props}>
          {getMultiValueLabel(data)}
        </components.MultiValue>
      );
    }
    return (
      <components.MultiValue data={data} {...props}>
        {children}
      </components.MultiValue>
    );
  }

  return MultiValueComponent;
}
